<template>
    <aside class="left-sidebar">
        <div class="scroll-sidebar d-print-none">
            <nav class="sidebar-nav">
                <ul id="sidebarnav">
                    <li class="sidebar-item" v-if="isBuyer()">
                        <router-link :to="{ name: 'dashboard'}" aria-expanded="false"
                                     class="sidebar-link waves-effect waves-dark" exact>
                            <i class="fas fa-tachometer-alt"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.DashboardOptions.Dashboard') }}</span>
                        </router-link>
                    </li>

                    <li class="nav-small-cap">
                        <i class="mdi mdi-dots-horizontal"></i>
                        <span class="hide-menu" v-if="isCoop()">{{ $t('WorkspaceMenubar.MarketplaceOptions.Marketplace') }}</span>
                        <span class="hide-menu" v-if="!isCoop()">{{ $t('WorkspaceMenubar.BuySellOptions["Shop & Supply"]') }}</span>
                    </li>

                    <li class="sidebar-item" v-if="currentUser.app_type === 'ACRECX_EXPRESS'">
                        <template v-if="currentOrg.role !== 'INVENTORY_MANAGER'">
                            <router-link :to="{ name: 'dashboard'}" aria-expanded="false"
                                         class="sidebar-link has-arrow waves-effect waves-dark">
                                <i class="fas fa-shopping-basket"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.ExpressOptions.Shop&Supply') }}</span>
                            </router-link>
                            <ul aria-expanded="false" class="collapse first-level">
                                <!-- Dashboard -->
                                <li class="sidebar-item">
                                    <router-link :to="{ name: 'dashboard'}" class="sidebar-link">
                                        <i class="fas fa-shopping-basket"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.ExpressOptions.Dashboard') }}</span>
                                    </router-link>
                                </li>
                                <!-- Inventory -->
                                <li class="sidebar-item">
                                    <router-link
                                            :to="{ name: 'expinventory', params: {expressid: currentOrg.express_id}}"
                                            aria-expanded="false" class="has-arrow sidebar-link">
                                        <i class="fa fa-store"/> <span class="hide-menu">Inventory</span>
                                    </router-link>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'expinventory', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fa fa-store-alt"/>Inventory
                                            </router-link>
                                            <router-link
                                                    :to="{ name: 'expwarehouses', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fa fa-warehouse"/>Warehouses
                                            </router-link>
                                            <router-link
                                                    :to="{ name: 'addexpwarehouse', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="far fa-plus-square"/>Add Warehouse
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Goods and Services -->
                                <li class="sidebar-item">
                                    <router-link
                                            :to="{ name: 'expresspurchases', params: {expressid: currentOrg.express_id}}"
                                            aria-expanded="false" class="has-arrow sidebar-link">
                                        <i class="fas fa-box-open"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.ExpressOptions.GoodsAndServices') }}</span>
                                    </router-link>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'purchasegoodsservices', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-box-open"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.GoodsAndServices')
                                                }}
                                            </router-link>
                                        </li>
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'addpurchasegoodsservices', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-plus-square"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.AddGoodsAndServices')
                                                }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Purchases -->
                                <li class="sidebar-item">
                                    <router-link
                                            :to="{ name: 'expresspurchases', params: {expressid: currentOrg.express_id}}"
                                            aria-expanded="false" class="has-arrow sidebar-link">
                                        <i class="fas fa-shopping-cart"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.ExpressOptions.Purchases') }}</span>
                                    </router-link>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'expresspurchases', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-shopping-cart"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.AllPO')
                                                }}
                                            </router-link>
                                        </li>
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'addexpresspurchase', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-cart-plus"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.AddPO')
                                                }}
                                            </router-link>
                                        </li>
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'sellers', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-users"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.AllSellers')
                                                }}
                                            </router-link>
                                        </li>
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'addseller', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-user-plus"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.AddSeller')
                                                }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Sales-->
                                <li class="sidebar-item">
                                    <a aria-expanded="false" class="has-arrow sidebar-link" href="javascript:void(0)">
                                        <i class="far fa-credit-card"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.ExpressOptions.Sales') }}</span>
                                    </a>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'buyers', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-users"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.AllBuyers')
                                                }}
                                            </router-link>
                                        </li>
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'addbuyer', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-user-plus"></i> {{
                                                $t('WorkspaceMenubar.ExpressOptions.AddBuyer')
                                                }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Label Maker -->
                                <li class="sidebar-item">
                                    <router-link :to="{ name: 'products', params: {expressid: currentOrg.express_id}}"
                                                 aria-expanded="false" class="has-arrow sidebar-link">
                                        <i class="fa fa-barcode"/> <span class="hide-menu">Label Maker</span>
                                    </router-link>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'products', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fa fa-tags"/>SKU Master
                                            </router-link>
                                            <router-link
                                                    :to="{ name: 'addproduct', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fa fa-tag"/>ADD SKU
                                            </router-link>
                                            <router-link
                                                    :to="{ name: 'label', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fa fa-qrcode"/>Create Label
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Invoices -->
                                <li class="sidebar-item">
                                    <router-link
                                            :to="{ name: 'expressinvoices', params: {expressid: currentOrg.express_id}}"
                                            aria-expanded="false" class="has-arrow sidebar-link">
                                        <i class="fas fa-dollar-sign"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.ExpressOptions.Invoices') }}</span>
                                    </router-link>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'expressinvoices', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-dollar-sign"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.ExpressOptions.AllInvoices') }}</span>
                                            </router-link>
                                        </li>
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'addexpressinvoice', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.ExpressOptions.NewInvoice') }}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Bills -->
                                <li class="sidebar-item">
                                    <router-link
                                            :to="{ name: 'expressbills', params: {expressid: currentOrg.express_id}}"
                                            aria-expanded="false" class="has-arrow sidebar-link">
                                        <i class="fas fa-file-invoice"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.Bills') }}</span>
                                    </router-link>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'expressbills', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-file-invoice"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllBills') }}</span>
                                            </router-link>
                                        </li>
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'addexpressbill', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AddBill') }}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Challans -->
                                <li class="sidebar-item">
                                    <router-link :to="{ name: 'challans', params: {expressid: currentOrg.express_id}}"
                                                 aria-expanded="false" class="has-arrow sidebar-link">
                                        <i class="fas fa-clipboard-list"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.ExpressOptions.Challans') }}</span>
                                    </router-link>
                                    <ul aria-expanded="false" class="collapse second-level">
                                        <li class="sidebar-item">
                                            <router-link
                                                    :to="{ name: 'challans', params: {expressid: currentOrg.express_id}}"
                                                    class="sidebar-link">
                                                <i class="fa fa-clipboard-list"/>{{
                                                $t('WorkspaceMenubar.ExpressOptions.Challans')
                                                }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                                <!-- Receipts -->
                                <li class="sidebar-item">
                                    <router-link
                                            :to="{ name: 'expressreceipts', params: {expressid: currentOrg.express_id}}"
                                            aria-expanded="false" class="sidebar-link">
                                        <i class="fas fa-copy"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Receipts') }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </template>
                        <template v-else>
                            <router-link :to="{ name: 'expinventory',  params: {expressid: currentOrg.express_id}}"
                                         aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark">
                                <i class="fa fa-store-alt"/>
                                <span class="hide-menu">{{ $t('WorkspaceMenubar.ExpressOptions.Shop&Supply') }}</span>
                            </router-link>
                            <ul aria-expanded="false" class="collapse first-level">
                                <li class="sidebar-item">
                                    <router-link
                                            :to="{ name: 'expinventory', params: {expressid: currentOrg.express_id}}"
                                            class="sidebar-link">
                                        <i class="fa fa-store-alt"/>{{
                                        $t('WorkspaceMenubar.MarketplaceOptions.Inventory')
                                        }}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                            :to="{ name: 'expwarehouses', params: {expressid: currentOrg.express_id}}"
                                            class="sidebar-link">
                                        <i class="fa fa-warehouse"/>{{
                                        $t('WorkspaceMenubar.MarketplaceOptions.Warehouses')
                                        }}
                                    </router-link>
                                </li>
                                <li class="sidebar-item">
                                    <router-link :to="{ name: 'challans', params: {expressid: currentOrg.express_id}}"
                                                 class="sidebar-link">
                                        <i class="fa fa-clipboard-list"/>{{
                                        $t('WorkspaceMenubar.ExpressOptions.Challans')
                                        }}
                                    </router-link>
                                </li>
                                <!--                                <li>-->
                                <!--                                    <router-link :to="{ name: 'newchallan', params: {expressid: currentOrg.express_id}}" class="sidebar-link">-->
                                <!--                                        <i class="fa fa-clipboard-check"/>{{ $t('WorkspaceMenubar.ExpressOptions.NewChallan')}}-->
                                <!--                                    </router-link>-->
                                <!--                                </li>-->
                            </ul>
                        </template>
                    </li>

                    <li class="sidebar-item" v-if="!isCoop() && currentUser.app_type === 'ACRECX_MARKETPLACE'">
                        <router-link :to="{ name: 'dashboard2'}" aria-expanded="false"
                                     class="sidebar-link has-arrow waves-effect waves-dark">
                            <i class="fas fa-shopping-basket"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.BuySellOptions["Shop & Supply"]') }}</span>
                        </router-link>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'dashboard2'}" class="sidebar-link">
                                    <i class="fas fa-shopping-basket"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.Dashboard') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'commodities', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-dolly"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Commodities') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'commodities', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-dolly"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllCommodities') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'newcommodity', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AddCommodity') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'purchases', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="sidebar-link">
                                    <i class="fas fa-shopping-cart"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.BuySellOptions.Purchases') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'sales', params: {marketplaceid: currentOrg.marketplace_id}}"
                                             aria-expanded="false" class="sidebar-link">
                                    <i class="far fa-credit-card"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.BuySellOptions.Sales') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'marketplaceinvoices', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-dollar-sign"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.BuySellOptions.Invoices') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'expressbills', params: {expressid: currentOrg.express_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-file-invoice"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.Bills') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'expressbills', params: {expressid: currentOrg.express_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-file-invoice"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllBills') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'addexpressbill', params: {expressid: currentOrg.express_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AddBill') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="sidebar-item" v-if="currentUser.app_type === 'ACRECX_EXPRESS'">
                                <router-link
                                        :to="{ name: 'purchasesreport', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-chart-bar"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Reports') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'purchasesreport', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-shopping-cart"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Purchase_Report') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'salesreport', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-credit-card"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Sale_Report') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-item" v-if="isCoop()">
                        <router-link :to="{ name: 'dashboard'}" aria-expanded="false"
                                     class="sidebar-link has-arrow waves-effect waves-dark">
                            <i class="fas fa-shopping-basket"></i><span class="hide-menu custom-margin-right">{{ $t('WorkspaceMenubar.MarketplaceOptions.Marketplace') }}</span>
                        </router-link>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'dashboard'}" class="sidebar-link">
                                    <i class="fas fa-shopping-basket"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.Dashboard') }}</span>
                                </router-link>
                            </li>

                            <!--    Reports -->
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'quality-report-list', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-chart-bar"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Reports') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item" v-if="is_bws_token_exist">
                                        <router-link
                                                :to="{ name: 'quality-report-list', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link" exact>
                                            <i class="fas fa-leaf"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.QualityReport') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item" v-if="is_bws_token_exist">
                                        <router-link
                                                :to="{ name: 'trace-report-list', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link" exact>
                                            <i class="fas fa-truck-moving"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.TraceReport') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'finance-report-list', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link" exact>
                                            <i class="fas fa-dollar-sign"></i><span class="hide-menu"> Financial Report</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'my-credentials', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link" exact>
                                            <i class="fas fa-file-alt"></i><span class="hide-menu"> My Documents</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'purchasesreport', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-shopping-cart"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Purchase_Report') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'salesreport', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-credit-card"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Sale_Report') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'invoicesreport', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-dollar-sign"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Invoice_Report') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <!--    Inventory -->
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'marketplaceinventory', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fa fa-store"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Inventory') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'marketplaceinventory', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-store-alt"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Inventory') }}</span>
                                        </router-link>
                                        <router-link
                                                :to="{ name: 'marketplacewarehouses', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-warehouse"></i><span class="hide-menu">  {{ $t('WorkspaceMenubar.MarketplaceOptions.Warehouses') }}</span>
                                        </router-link>
                                        <router-link
                                                :to="{ name: 'marketplacechallans', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-clipboard-list"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.Challans') }}</span>
                                        </router-link>
                                        <router-link
                                                :to="{ name: 'deliverynotes', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-truck-loading"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.DeliveryNotes') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <!--    Commodity   -->
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'commodities', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-dolly"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Commodities') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'commodities', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-dolly"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllCommodities') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'newcommodity', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AddCommodity') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'purchases', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-shopping-cart"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Purchases') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'purchases', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-shopping-cart"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllPurchases') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'newpo', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-cart-arrow-down"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.PurchaseOrder') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'sales', params: {marketplaceid: currentOrg.marketplace_id}}"
                                             aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="far fa-credit-card"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Sales') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'sales', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="far fa-credit-card"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllSales') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'newsale', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="far fa-file-alt"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.SaleOrder') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'marketplaceinvoices', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-dollar-sign"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.Invoices') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'marketplaceinvoices', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-dollar-sign"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllInvoices') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'addmarketplaceinvoice', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.NewInvoice') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'marketplace-bills', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fas fa-file-invoice"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.Bills') }}</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'marketplace-bills', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-file-invoice"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AllBills') }}</span>
                                        </router-link>
                                    </li>
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'add-marketplace-bill', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceOptions.AddBill') }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <!-- Receipts -->
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'marketplace-receipts', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="sidebar-link">
                                    <i class="fas fa-copy"></i> <span class="hide-menu">{{ $t('WorkspaceMenubar.MarketplaceOptions.Receipts') }}</span>
                                </router-link>
                            </li>
                            <!--    Label Maker -->
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'marketplaceproducts', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        aria-expanded="false" class="has-arrow sidebar-link">
                                    <i class="fa fa-barcode"/> <span class="hide-menu">Label Maker</span>
                                </router-link>
                                <ul aria-expanded="false" class="collapse second-level">
                                    <li class="sidebar-item">
                                        <router-link
                                                :to="{ name: 'marketplaceproducts', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fa fa-tags"/>SKU Master
                                        </router-link>
                                        <router-link
                                                :to="{ name: 'marketplaceaddproduct', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fa fa-tag"/>ADD SKU
                                        </router-link>
                                        <router-link
                                                :to="{ name: 'marketplacelabel', params: {marketplaceid: currentOrg.marketplace_id}}"
                                                class="sidebar-link">
                                            <i class="fa fa-qrcode"/>Create Label
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </li>
                    <li class="sidebar-item" v-if="is_bws_token_exist">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-seedling"></i><span class="hide-menu custom-margin-right">{{ $t('WorkspaceMenubar.GrowersOptions.Members') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'members', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-seedling"></i> {{
                                    $t('WorkspaceMenubar.GrowersOptions.ViewMembers')
                                    }}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-item" v-if="isCoop()">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-users"></i><span class="hide-menu custom-margin-right">{{ $t('WorkspaceMenubar.GrowersOptions.Growers') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'growers', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-users"></i> {{
                                    $t('WorkspaceMenubar.GrowersOptions.ViewGrowers')
                                    }}
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'addgrower', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-user-plus"></i> {{ $t('WorkspaceMenubar.GrowersOptions.AddGrower')
                                    }}
                                </router-link>
                            </li>
                        </ul>
                    </li>


                    <li class="sidebar-item"
                        v-if="currentUser.app_type === 'ACRECX_EXPRESS' && currentOrg.role === 'ORG_ADMIN'">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-book"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.ExpressOptions.Contractbook') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'contracts', params: {expressid: currentOrg.express_id}}"
                                             class="sidebar-link">
                                    <i class="fas fa-handshake"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.ExpressOptions.AllContracts') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'newcontractstep1', params: {expressid: currentOrg.express_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.ExpressOptions.NewContract') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item" v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-hand-holding-usd"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.OffersOptions.Offers') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'alloffers', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-hand-holding"></i>{{
                                    $t('WorkspaceMenubar.OffersOptions.ShowOffers')
                                    }}
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'myoffers', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-hand-holding"></i>{{
                                    $t('WorkspaceMenubar.OffersOptions.MyOffers')
                                    }}
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'offer_step1', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-plus"></i>{{ $t('WorkspaceMenubar.OffersOptions.PostNewOffer') }}
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="sidebar-item" v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-handshake"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.TradesOptions.Trades') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'mytrades', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link" exact>
                                    <i class="far fa-handshake"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.TradesOptions.MyTrades') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item" v-if="is_bws_token_exist">
                                <router-link
                                        :to="{ name: 'trade-report-list', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link" exact>
                                    <i class="fas fa-clipboard-list"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.TradesOptions.Report')}}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item" v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-book"></i><span class="hide-menu m-r-20">{{ $t('WorkspaceMenubar.MarketplaceContractOptions.Contractbook') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'marketplace-contracts', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-handshake"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceContractOptions.AllContracts') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link
                                        :to="{ name: 'markrtplacecontractstep1', params: {marketplaceid: currentOrg.marketplace_id}}"
                                        class="sidebar-link">
                                    <i class="fas fa-plus-square"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MarketplaceContractOptions.NewContract') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>


                    <li class="sidebar-item" v-if="isAdmin() && currentUser.app_type === 'ACRECX_MARKETPLACE'">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-building"></i><span class="hide-menu custom-margin-right">{{ $t('WorkspaceMenubar.OrgAdminOptions.OrgAdmin') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'orgprofile'}" class="sidebar-link" exact>
                                    <i class="fas fa-building"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Profile') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'orgmembers'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-account-multiple"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Members') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'viewsettings'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-settings"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Settings') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'taxes'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-percent"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Taxes') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'orgsubscription'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-seal"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions["Subscription Plan"]') }}</span>
                                </router-link>
                            </li>
                            <!--                            <li class="sidebar-item">-->
                            <!--                                <router-link :to="{ name: 'orginvoice'}" class="sidebar-link" exact>-->
                            <!--                                    <i class="mdi mdi-file-document"></i><span class="hide-menu"> {{$t('WorkspaceMenubar.OrgAdminOptions.Invoice')}}</span>-->
                            <!--                                </router-link>-->
                            <!--                            </li>-->
                            <!--                            <li class="sidebar-item">-->
                            <!--                                <router-link :to="{ name: 'plans'}" class="sidebar-link" exact>-->
                            <!--                                    <i class="mdi mdi-wallet-membership"></i><span class="hide-menu"> {{$t('WorkspaceMenubar.OrgAdminOptions.MembershipPlan')}}</span>-->
                            <!--                                </router-link>-->
                            <!--                            </li>-->
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'accounts'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-bank"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.BankAccounts') }}</span>
                                </router-link>
                            </li>
                            <!--                            <li class="sidebar-item">-->
                            <!--                                <router-link :to="{ name: 'wallet'}" class="sidebar-link" exact>-->
                            <!--                                    <i class="mdi mdi-wallet"></i><span class="hide-menu"> {{$t('WorkspaceMenubar.OrgAdminOptions.Wallet')}}</span>-->
                            <!--                                </router-link>-->
                            <!--                            </li>-->
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'integration'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-swap-horizontal"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.ApiIntegrations') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item"
                        v-if="currentUser.app_type === 'ACRECX_EXPRESS' && currentOrg.role === 'ORG_ADMIN'">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-building"></i><span class="hide-menu">{{ $t('WorkspaceMenubar.OrgAdminOptions.OrgAdmin') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'orgprofile'}" class="sidebar-link" exact>
                                    <i class="fas fa-building"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Profile') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'orgmembers'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-account-multiple"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Members') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'viewsettings'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-settings"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Settings') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'taxes'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-percent"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.Taxes') }}</span>
                                </router-link>
                            </li>
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'parnershiptype'}" class="sidebar-link" exact>
                                    <i class="fas fa-handshake"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.OrgAdminOptions.PartnershipType') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-item">
                        <a aria-expanded="false" class="sidebar-link has-arrow waves-effect waves-dark" exact
                           href="javascript:void(0)">
                            <i class="fas fa-user-circle"></i><span class="hide-menu m-r-15">{{ $t('WorkspaceMenubar.MyAccountOptions.MyAccount') }}</span>
                        </a>
                        <ul aria-expanded="false" class="collapse first-level">
                            <li class="sidebar-item">
                                <router-link :to="{ name: 'viewprofile'}" class="sidebar-link" exact>
                                    <i class="mdi mdi-account"></i><span class="hide-menu"> {{ $t('WorkspaceMenubar.MyAccountOptions.AccountInfo') }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    </aside>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "WorkspaceMenubar",
        mounted() {
            this.is_bws_token_exist = JSON.stringify(localStorage.getItem('bws_token')) !== 'null' ? true : false;
            this.$nextTick(() => {
                this.menu();
            });
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                is_bws_token_exist: false
            }
        },
        methods: {
            handleLogout() {
                this.$store.commit("LOGOUT");
                this.$router.replace("/auth/login");
            },
            isAdmin() {
                return this.currentOrg && this.currentOrg.role === 'ORG_ADMIN';
            },
            isCoop() {
                return this.currentOrg && this.currentOrg.type === 'COOP';
            },
            isBuyer() {
                return this.currentOrg && this.currentOrg.type === 'BUYER';
            },
            menu() {
                $(function () {
                    "use strict";
                    let url = window.location + "";
                    let path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");
                    let element = $('ul#sidebarnav a').filter(function () {
                        return this.href === url || this.href === path;// || url.href.indexOf(this.href) === 0;
                    });
                    element.parentsUntil(".sidebar-nav").each(function (index) {
                        if ($(this).is("li") && $(this).children("a").length !== 0) {
                            $(this).children("a").addClass("active");
                            $(this).parent("ul#sidebarnav").length === 0
                                ? $(this).addClass("active")
                                : $(this).addClass("selected");
                        } else if (!$(this).is("ul") && $(this).children("a").length === 0) {
                            $(this).addClass("selected");

                        } else if ($(this).is("ul")) {
                            $(this).addClass('in');
                        }
                    });

                    element.addClass("active");
                    $('#sidebarnav a').on('click', function (e) {

                        if (!$(this).hasClass("active")) {
                            // hide any open menus and remove all other classes
                            $("ul", $(this).parents("ul:first")).removeClass("in");
                            $("a", $(this).parents("ul:first")).removeClass("active");

                            // open our new menu and add the open class
                            $(this).next("ul").addClass("in");
                            $(this).addClass("active");

                        } else if ($(this).hasClass("active")) {
                            $(this).removeClass("active");
                            $(this).parents("ul:first").removeClass("active");
                            $(this).next("ul").removeClass("in");
                        }
                    });
                    $('#sidebarnav >li >a.has-arrow').on('click', function (e) {
                        e.preventDefault();
                    });
                });
            }
        }
    }
</script>

<style scoped>
    .custom-margin-right {
        margin-right: 15px
    }
</style>
